import {localizeImage} from '../../i18n/images';
import {useTranslation} from '../../i18n/translation';
import React from "react";
import Navigation from "../utils/Navigation";
import "../../css/lizing/lizingFinance.css";
import "../../css/lizing/leasing-refresh.css";
import '../../css/lizing/rosagro.css';
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import {Link, useLocation} from "react-router-dom";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";
import {LeasingEquipment} from "./LizingRosagro";

// Картинки теперь в public → строковые URL.
const Guarantee = "/images/lizing/IconGuarantee.webp";
const Gazprom   = "/images/lizing/gazprom.webp";
const Lukoil    = "/images/lizing/lukoil.webp";
const Rosneft   = "/images/lizing/rosneft.webp";
const Sibur     = "/images/lizing/sibur.webp";
const Taneco    = "/images/lizing/taneco.webp";
const Tatneft   = "/images/lizing/tatneft.webp";

const ROSAGRO_LEASING = [
    {
        url: '/lizing/lizing_rosagro',
        title: 'Лизинг от АО «Росагролизинг»',
        image: 'lizing/ros.webp'
    }
];

export default function LizingFinance(){
    const {english, t} = useTranslation();

    const location = useLocation();
    const data = findElementByLink(siteStructure, location.pathname.replace(/^\/en(?=\/|$)/, ""))
    const seo = data?.seo? data.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}
    const { theme } = useTheme()


    return (
        <>
            <Navigation/>
            <SeoHelmet
                title={t(seo.title)}
                description={t(seo.description)}
            />
            <div className={`overlay`}>
                <div className={`complexBack ${theme}`}> </div>
                <div className={`lizingFinance-container leasing-page ${theme}`}>
                    <section className="leasing-hero">
                        <div className="leasing-hero-copy">
                            <span className="leasing-eyebrow">{t("Сеспель-Финанс · Лизинг от производителя")}</span>
                            <h1>{t("Ваша техника.")}<br/>{t("Новые возможности.")}</h1>
                            <p>{t("Подберите полуприцеп для своего бизнеса. Мы поможем с комплектацией, оформлением и финансированием покупки.")}</p>
                            <div className="leasing-actions">
                                <a className="leasing-button" href="#leasing-programs">{t("Сравнить программы")}<span aria-hidden="true">↗</span></a>
                                <a className="leasing-contact" href="tel:+79379427106">{t("Обсудить со специалистом ↗")}</a>
                            </div>
                        </div>
                        <div className="leasing-hero-image">
                            <img src={localizeImage("/images/lizing/lizingSespelFinance.webp", english)} alt={t("Техника Сеспель для приобретения в лизинг")}/>
                            <span>{t("Напрямую от завода «Сеспель»")}</span>
                        </div>
                    </section>
                    <div className="leasing-section-heading" id="leasing-programs">
                        <span className="leasing-eyebrow">{t("01 / Финансирование")}</span>
                        <h2>{t("Выберите вашу программу")}</h2>
                        <p>{t("Сравните удорожание, первоначальный взнос и срок лизинга.")}</p>
                    </div>
                    <div className={`lizingProgramsWrapper ${theme}`}>
                        <LizingProgram per={"7,2"} prepaid={"49"} duration={"1 год"}/>
                        <LizingProgram per={"7,9"} prepaid={"40"} duration={"2 года"}/>
                        <LizingProgram per={"10,9"} prepaid={"30"} duration={"3 года"}/>
                    </div>
                    <div className={"lizingFinanceFeatures"}>
                        <h1>{t("ПРЕИМУЩЕСТВА КОМПАНИИ")}</h1>

                        <div className={"lizingFinanceFeaturesInfo"}>
                            <div>
                                <h1>{t("О группе компаний \"Сеспель\"")}</h1>
                                <p>{t("Завод «Сеспель» работает с 1999 года и за эти годы успешной работы реализовал более 5500 полуприцепов и автоцистерн для компаний по всей России и странам СНГ.")}</p>
                            </div>
                            <div className={`lizingFinanceFeaturesInfoBlock ${theme}`}>
                                <div>
                                    <h1>{t("МИНИМАЛЬНЫЙ")}</h1>
                                    <p>{t("пакет документов")}</p>
                                </div>
                                <div>
                                    <h1>{t("ЗА 1 ДЕНЬ")}</h1>
                                    <p>{t("Получите решение о выдаче")}</p>
                                </div>
                            </div>
                            <div className={`lizingFinanceFeaturesInfoBlock ${theme}`}>
                                <div>
                                    <h1>5%</h1>
                                    <p>{t("первоначальный взнос")}</p>
                                </div>
                                <div>
                                    <h1>{t("БЕЗ НАЦЕНКИ")}</h1>
                                    <p>{t("По заводским ценам")}</p>
                                </div>
                            </div>
                        </div>
                        <p>{t("ООО ЛК \"Сеспель-финанс\" – это дочерняя компания завода-изготовителя ЗАО «Сеспель». Наша цель – оказание помощи в выборе, оформлении и финансировании покупки полуприцепов «Сеспель» для организаций, работающих в сфере перевозок, строительства, сельского хозяйства, а также в нефтегазовой, химической, пищевой и перерабатывающей промышленности. Лизинг от «Сеспель-Финанс» поможет вам приобрести технику простым, оперативным и удобным способом, оставляя вам больше времени для ведения бизнеса и достижения целей вашей компании. Мы консультируем, подбираем технику, принимаем решение по лизингу за 1 день, а также рассчитываем стоимость лизинга бесплатно!")}</p>
                    </div>
                    <div className={"lizingFinancePartners"}>
                        <div>
                            <h1>{t("РАБОТАЕМ С КРУПНЕЙШИМИ ИГРОКАМИ НЕФТЕГАЗОВОЙ ОТРАСЛИ")}</h1>
                            <p>{t("После аванса в 5% мы изготавливаем полуприцеп в срок до 30 дней и сообщаем вам о его готовности.")}</p>
                            <p>{t("Вы получаете полуприцеп и сразу начинаете зарабатывать, оплачивая лизинговые платежи.")}</p>
                        </div>
                        <div>
                            <img src={Gazprom} alt="no-img"/>
                            <img src={Tatneft} alt="no-img"/>
                            <img src={Lukoil} alt="no-img"/>
                            <img src={Rosneft} alt="no-img"/>
                            <img src={Taneco} alt="no-img"/>
                            <img src={Sibur} alt="no-img"/>
                        </div>
                    </div>

                    <h1 className={"lizingFinanceAdvantagesH3"}>{t("ДОПОЛНИТЕЛЬНЫЕ ПРЕИМУЩЕСТВА ОТ ООО ЛК \"СЕСПЕЛЬ-ФИНАНС\"")}</h1>
                    <div className={"lizingFinanceAdvantages"}>
                        <LizingAdvatageBlock headText1={"Решение"} headText2={"за 24 часа"} head={true}
                                             bodyText={`Решение по лизингу принимается за 1 день`}/>

                        <LizingAdvatageBlock headText1={"Вносите 5% и"} headText2={"забираете технику"} head={false}
                                             bodyText={
                                                 `Первоначальный взнос – 5%. Забрать технику можно сразу после 
                                             внесения 5% суммы, а не 70%, как при обычной покупке.`}
                        />

                        <LizingAdvatageBlock headText1={"Минимум"} headText2={"документов"} head={true}
                                             bodyText={
                                                 `Минимальный пакет документов вследствие того,
                                             что ООО ЛК "Сеспель-финанс"– это лизинговая компания ЗАО "Сеспель".`}/>

                        <LizingAdvatageBlock headText1={"Без"} headText2={"залога"} head={false}
                                             bodyText={
                                                 `В отличие от банковского кредита, в лизинге 
                                             от ООО ЛК "Сеспель-финанс" вы не вносите никакого
                                              дополнительного залога`}
                        />

                        <LizingAdvatageBlock headText1={"Меньше платеж"} headText2={"и каско до 5 лет"} head={false} up={false}
                                             bodyText={
                                                 `Лизинг на пять лет позволяет уменьшить
                                              ежемесячный платежи получить 5 лет КАСКО,
                                              учтенных в лизинговых платежах.`}
                        />

                        <LizingAdvatageBlock headText1={"Принцип"} headText2={"одного окна"} head={true} up={false}
                                             bodyText={
                                                 `Действует "принцип одного окна".
                                             Все технические вопросы, связанныес
                                              производством и вопросы оформления
                                               купли-продажи решает сама лизинговая компания`}
                        />

                        <LizingAdvatageBlock headText1={"Техника платит"} headText2={"сама за себя"} head={false} up={false}
                                             bodyText={
                                                 `Вы вносите лизинговые платежи по
                                              договору равными суммами в течение
                                               5 лет. Оплачивайте полуприцеп с
                                                заработанных им же денег.`}
                        />

                        <LizingAdvatageBlock headText1={"Без скрытых"} headText2={"комиссий"} head={true} up={false}
                                             bodyText={
                                                 `Наша лизинговая программа отличается
                                              абсолютной прозрачностью. Вы сразу
                                               получаете полную информацию обо всех
                                                условиях лизинга и подробный график платежей`}
                        />
                    </div>

                    <h1 className={"lizingFinanceAdvantagesH3"}>{t("СЭКОНОМЬТЕ ДО 500 000 РУБ.")}</h1>
                    <p>{t("Лизинговые платежи в полном объеме уменьшают налогооблагаемую прибыль.")}</p>
                    <p>{t("НДС с суммы лизинговых платежей в полном объеме принимаются к вычету.")}</p>
                    <p>{t("По окончании срока действия лизинга имущество переходит в вашу собственность по минимальной стоимости (1000 рублей).")}</p>

                    <h1 className={"lizingFinanceAdvantagesH3"}>{t("КАК МЫ РАБОТАЕМ")}</h1>
                    <div className={`lizingFinanceWorks ${theme}`}>
                        <div className={`lizingFinanceWorksDay`}>
                            <div>
                                <span>1</span>
                                <span>{t("день")}</span>
                            </div>
                        </div>
                        <div className={"lizingFinanceWorksSteps"}>
                            <LizingFinanceStep step={1} text={"Мы подбираем вам подходящий полуприцеп (бензовоз или битумовоз) и его комплектацию"}/>
                            <LizingFinanceStep step={2} text={"Вы представляете пакет всего из трех документов"}/>
                            <LizingFinanceStep step={3} text={"Получаете решение по лизингу всего за 1 день"}/>
                            <div> </div>
                            <LizingFinanceStep step={4} text={"При положительном решении присылаете оставшиесся документы"}/>
                            <LizingFinanceStep step={5} text={"Заключаем с вами договор лизинга и обговариваем условия получения техники."}/>
                        </div>
                    </div>
                    <p>{t("После аванса в 5% мы изготавливаем полуприцеп в срок до 30 дней и сообщаем вам о его готовности. Вы получаете полуприцеп и сразу начинаете зарабатывать, оплачивая лизинговые платежи.")}</p>
                    <h1>{t("ГАРАНТИЯ БЕЗ ОГРАНИЧЕНИЯ ПРОБЕГА")}</h1>
                    <div className={`lizingFinanceGuarantee ${theme}`}>
                        <div>
                            <img src={Guarantee} alt="no-img"/>
                            <p>{t("Вы получаете 5 лет гарантии на оси от производителя и \"Сеспель\".")}</p>
                        </div>
                        <div>
                            <img src={Guarantee} alt="no-img"/>
                            <p>{t("Вы получаете 1 год гарантии на герметичность цистерны от протечек от ЗАО \"Сеспель\".")}</p>
                        </div>
                        <div>
                            <img src={Guarantee} alt="no-img"/>
                            <p>{t("Вы получаете 5 лет страхования по КАСКО, которое уже включено в лизинговые платежи.")}</p>
                        </div>
                    </div>
                    <div className={"lizingFinanceTerms"}>
                        <div>
                            <h1>{t("УСЛОВИЯ ОПЛАТЫ И ДОСТАВКИ")}</h1>
                            <p>{t("«Сеспель» – крупнейшее предприятие России по производству полуприцепов.")}</p>
                            <div className={"lizingFinanceNumber"}>
                                <span>{t("Звоните!")}</span>
                                <a className="leasing-phone" href="tel:+79379427106">+7 (937) 942-71-06</a>
                                <p>{t("Наш ведущий специалист проконсультирует вас по всем вопросам.")}</p>
                            </div>
                        </div>
                        <div className={`lizingFinanceTermsRightColumn ${theme}`}>
                            <div>
                                <div>
                                    <p>{t("УСЛОВИЯ")}</p>
                                    <p>{t("ОПЛАТЫ")}</p>
                                </div>
                                <div>
                                    <p>{t("Оплата производится безналичным перечислением В лизинг (на 5 лет, 5%-первоначальный взнос)")}</p>
                                </div>
                            </div>

                            <div>
                                <div>
                                    <p>{t("УСЛОВИЯ")}</p>
                                    <p>{t("ДОСТАВКИ")}</p>
                                </div>
                                <div>
                                    <p>{t("Самовывоз с завода вашим тягачом (завод находится в селе Москакасы Моргаушского района Чувашии – на трассе М7).")}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <LeasingEquipment
                        items={ROSAGRO_LEASING}
                        theme={theme}
                        id="rosagro-program"
                        eyebrow="Альтернативная программа"
                        title="Лизинг от АО «Росагролизинг»"
                        description="Федеральная программа для АПК: первый взнос от 0%, срок до 7 лет, решение по заявке за 1 день."
                    />

                    <Link className="rosagro-back" to={english ? "/en/lizing" : "/lizing"}>{t("← Все программы лизинга")}</Link>
                </div>
            </div>
        </>
    )
}

function LizingProgram({per, prepaid, duration}){
    const {english, t} = useTranslation();

    const { theme } = useTheme()

    return (
        <div>
            <div className={`lizingProgramText ${theme}`}>
                <div>
                    <span className="number_art">{String(per).replace(english ? "," : ".", english ? "." : ",")}</span>
                    <span className="percent_art">%</span>
                    <br/>
                    <span>{t("удорожания")}</span>
                </div>
                <ul>
                    <li>
                        <span>{t("Аванс:")}</span>
                        <span>{prepaid}%</span>
                    </li>
                    <li>
                        <span>{t("Срок:")}</span>
                        <span>{t(duration)}</span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

function LizingAdvatageBlock({headText1, headText2, bodyText, up=true, head=false}){
    const {t} = useTranslation();

    return (
        <div>

            <div className={`${head? "lizingFinanceAdvantagesHead" : "lizingFinanceAdvantagesNoHead"} ${up? "" : "lizingFinanceAdvantagesBottom"}`}>
                <p>{t(headText1)}</p>
                <p>{t(headText2)}</p>
            </div>


            <div className={`lizingFinanceAdvantagesBody`}>
                <p>{t(bodyText)}</p>
            </div>
        </div>
    )

}

function LizingFinanceStep({step, text}){
    const {t} = useTranslation();

    return (
        <div>
            <div>
                <span>{step}</span>
                <span>{t("шаг")}</span>
                <p>{t(text)}</p>
            </div>
        </div>
    )
}
